// FR-W10: success state. Prefers the card arriving on the SSE stash-scoped
// stream; falls back to direct navigation after 5s (the card page fetches on
// its own). Also navigates immediately once the streamed card shows up.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStashScopedStore } from '../../store/stash-scoped/context';

const SSE_WAIT_MS = 5000;

interface DoneStepProps {
  stashCardId: string;
  createdVendor: boolean;
}

export function DoneStep({ stashCardId, createdVendor }: DoneStepProps): React.JSX.Element {
  const navigate = useNavigate();
  const cardArrived = useStashScopedStore(
    (state) => state.allStashCards.some((card) => card.recordID === stashCardId));

  useEffect(() => {
    if (cardArrived) {
      navigate(`/app/stashcards/${stashCardId}`);
      return undefined;
    }
    const timer = setTimeout(() => navigate(`/app/stashcards/${stashCardId}`), SSE_WAIT_MS);
    return () => clearTimeout(timer);
  }, [cardArrived, navigate, stashCardId]);

  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center">
      <span aria-hidden className="text-3xl">🎉</span>
      <p className="m-0 text-base font-semibold text-foreground">Saved to your STASH</p>
      <p className="m-0 text-sm text-muted-foreground">
        {createdVendor ? 'New card created — opening it now…' : 'Added to the existing card — opening it now…'}
      </p>
    </div>
  );
}
